module.exports = __webpack_public_path__ + "assets/img/driver-btn-0e45b6b9.png";